import { ILSUserNotify } from '@common/components';
import { CoordError } from '@common/types/general/check-coords';

export const showError = (error: CoordError) => {
  const { type, message, duration, key } = error;
  ILSUserNotify(type, message, duration, key);
};
